import {Container, Carousel, Image} from 'react-bootstrap';
import aa from '../assets/slider/aa.png';


import sider1 from '../assets/slider/1BANNER.png';
import sider2 from '../assets/slider/2BANNER.png';
import sider3 from '../assets/slider/3BANNER.png';

import { useNavigate } from 'react-router-dom';
function MyCarousel({data}) {
    const navigate = useNavigate();

 
    return (
    <Container>
        <Carousel data-bs-theme="dark" className='mt-4 mainCarousel'>
        <Carousel.Item className='cursor-pointer' onClick={()=>navigate("/mobile")}>
                <Image src={aa} fluid className='w-100' />
            </Carousel.Item>
        <Carousel.Item className='cursor-pointer'onClick={()=>navigate("/detay/4899/Ataturk")}>
            <Image src={sider1} fluid className='w-100' />
        </Carousel.Item>
        <Carousel.Item className='cursor-pointer'onClick={()=>navigate("/detay/4899/Ataturk")}>
            <Image src={sider2} fluid className='w-100' />
        </Carousel.Item>
        <Carousel.Item className='cursor-pointer'onClick={()=>navigate("/detay/4899/Ataturk")}>
            <Image src={sider3} fluid className='w-100' />
        </Carousel.Item>
        {/* <Carousel.Item className='cursor-pointer' onClick={()=>navigate("/detay/4899/Ataturk")}>
            <Image src={sider3} fluid className='w-100' />
        </Carousel.Item> */}
{/* 
        <Carousel.Item>
            <Image src={s1} fluid className='w-100' />
        </Carousel.Item>

        <Carousel.Item>
            <Image src={s2} fluid className='w-100' />
        </Carousel.Item>

        {data.map((item,key)=>
           <Carousel.Item key={key}>
           <Image src={s2} fluid className='w-100' />
       </Carousel.Item>
        )} */}
        </Carousel>
    </Container>
  );
}

export default MyCarousel;